import * as Types from '../../../../../__generated__/types';

import { gql } from '@apollo/client';
import { GroupDataFragmentDoc } from '../../../components/__generated__/groupBasicInfo.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PublicCommunityGroupsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PublicCommunityGroupsQuery = { __typename?: 'Query', publicGroups: Array<{ __typename?: 'CommunityGroup', ownerId: string, id: string, uuid: string, name: string, description?: string | null, members: Array<{ __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null }> }> };


export const PublicCommunityGroupsDocument = gql`
    query PublicCommunityGroups {
  publicGroups {
    ownerId
    ...GroupData
  }
}
    ${GroupDataFragmentDoc}`;

/**
 * __usePublicCommunityGroupsQuery__
 *
 * To run a query within a React component, call `usePublicCommunityGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicCommunityGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicCommunityGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicCommunityGroupsQuery(baseOptions?: Apollo.QueryHookOptions<PublicCommunityGroupsQuery, PublicCommunityGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicCommunityGroupsQuery, PublicCommunityGroupsQueryVariables>(PublicCommunityGroupsDocument, options);
      }
export function usePublicCommunityGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicCommunityGroupsQuery, PublicCommunityGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicCommunityGroupsQuery, PublicCommunityGroupsQueryVariables>(PublicCommunityGroupsDocument, options);
        }
// @ts-ignore
export function usePublicCommunityGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PublicCommunityGroupsQuery, PublicCommunityGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<PublicCommunityGroupsQuery, PublicCommunityGroupsQueryVariables>;
export function usePublicCommunityGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicCommunityGroupsQuery, PublicCommunityGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<PublicCommunityGroupsQuery | undefined, PublicCommunityGroupsQueryVariables>;
export function usePublicCommunityGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicCommunityGroupsQuery, PublicCommunityGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicCommunityGroupsQuery, PublicCommunityGroupsQueryVariables>(PublicCommunityGroupsDocument, options);
        }
export type PublicCommunityGroupsQueryHookResult = ReturnType<typeof usePublicCommunityGroupsQuery>;
export type PublicCommunityGroupsLazyQueryHookResult = ReturnType<typeof usePublicCommunityGroupsLazyQuery>;
export type PublicCommunityGroupsSuspenseQueryHookResult = ReturnType<typeof usePublicCommunityGroupsSuspenseQuery>;
export type PublicCommunityGroupsQueryResult = Apollo.QueryResult<PublicCommunityGroupsQuery, PublicCommunityGroupsQueryVariables>;